import { render, staticRenderFns } from "./AttributeFormAdd.vue?vue&type=template&id=cc176002&"
import script from "./AttributeFormAdd.vue?vue&type=script&lang=js&"
export * from "./AttributeFormAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports